import { render, staticRenderFns } from "./category_edit.vue?vue&type=template&id=0477d4b2&scoped=true"
import script from "./category_edit.vue?vue&type=script&lang=js"
export * from "./category_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0477d4b2",
  null
  
)

export default component.exports